export default function PrivacyPolicy() {
    return (
        <div className="w-full bg-white">
            <div className="max-w-5xl mx-auto px-6 py-14">

                {/* PAGE TITLE */}
                <h1 className="text-3xl font-extrabold text-gray-900 mb-6">
                    Privacy Policy
                </h1>

                <p className="text-gray-700 leading-relaxed mb-6">
                    At <strong>BlogySports</strong>, your privacy is important to us. This
                    Privacy Policy explains how we collect, use, and protect your
                    information when you visit our sports news and content platform.
                </p>

                {/* INFORMATION WE COLLECT */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Information We Collect
                </h2>

                <p className="text-gray-700 leading-relaxed mb-4">
                    We may collect personal information that you voluntarily provide to
                    us, such as your name and email address, when you contact us or
                    subscribe to updates.
                </p>

                <p className="text-gray-700 leading-relaxed mb-6">
                    We also automatically collect non-personal information such as browser
                    type, device details, IP address, pages visited, and usage behavior.
                    This helps us understand how visitors use BlogySports and improve our
                    content.
                </p>

                {/* HOW WE USE INFORMATION */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    How We Use Your Information
                </h2>

                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
                    <li>To respond to inquiries and support requests</li>
                    <li>To improve sports content, features, and user experience</li>
                    <li>To analyze website traffic and performance</li>
                    <li>To comply with legal and regulatory requirements</li>
                </ul>

                {/* COOKIES */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Cookies and Tracking Technologies
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    BlogySports uses cookies and similar technologies to enhance browsing
                    experience, analyze traffic, and serve relevant content. Cookies are
                    small data files stored on your device.
                </p>

                <p className="text-gray-700 leading-relaxed mb-6">
                    You may disable cookies through your browser settings. However, some
                    parts of the website may not function properly if cookies are disabled.
                </p>

                {/* GOOGLE ADS */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Google Advertising & Third-Party Services
                </h2>

                <p className="text-gray-700 leading-relaxed mb-4">
                    BlogySports may use Google AdSense and other third-party advertising
                    partners to display advertisements. These services may use cookies,
                    including the DoubleClick cookie, to show ads based on your visits to
                    this and other websites.
                </p>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Google’s use of advertising cookies enables it and its partners to
                    serve personalized ads. Users can opt out of personalized advertising
                    by visiting the Google Ads Settings page.
                </p>

                {/* THIRD PARTY LINKS */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Third-Party Links
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    BlogySports may include links to third-party websites for reference or
                    additional information. We are not responsible for the privacy
                    practices or content of external websites and encourage users to
                    review their privacy policies.
                </p>

                {/* DATA SECURITY */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Data Security
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    We take reasonable measures to protect your information. However, no
                    method of transmission over the internet or electronic storage is
                    completely secure, and we cannot guarantee absolute security.
                </p>

                {/* CHILDREN */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Children’s Information
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    BlogySports does not knowingly collect personal information from
                    children under the age of 13. If you believe that a child has provided
                    personal data on our website, please contact us immediately so we can
                    remove it.
                </p>

                {/* POLICY UPDATES */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Updates to This Privacy Policy
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    We may update this Privacy Policy periodically. Any changes will be
                    posted on this page and will become effective immediately upon
                    publication.
                </p>

                {/* CONTACT */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Contact Us
                </h2>

                <p className="text-gray-700 leading-relaxed mb-10">
                    If you have any questions or concerns regarding this Privacy Policy,
                    please contact us at{" "}
                    <strong>contact@blogysports.com</strong>.
                </p>

                <p className="text-sm text-gray-500">
                    Last updated: {new Date().toLocaleDateString("en-IN")}
                </p>

            </div>
        </div>
    );
}
